export { default } from "./TableHead.mjs";
export { default as tableHeadClasses } from "./tableHeadClasses.mjs";
export * from "./tableHeadClasses.mjs";